/**
 * The minimum a story needs to render as a card. Deliberately looser than any
 * one query's row type — `StoryMetaV1` (nav/folder reads) and `AuthorPageStory`
 * both satisfy it, which is the whole point: one card language, many readers.
 *
 * Optional fields are `?: string | null` rather than `string | null` so both
 * shapes assign cleanly (the view types differ on which columns they denullify).
 */
export interface StoryCardStory {
  fullSlug: string
  title: string
  noindex: boolean
  publishedAt: string
  imageUrl?: string | null
  metaDescription?: string | null
  republishedAt?: string | null
  sponsor?: string | null
}

/**
 * How a card reports clicks. Article grids and author archives opt out (the
 * link is the content, and tracking every headline drowns the funnel); pages
 * where a story click competes with a conversion pass a funnel position.
 */
export type StoryCardTracking = 'ignore' | { eventName: string; position: string; origin: string }

/** Expands a tracking choice into the `data-*` attributes the analytics engine reads. */
export const trackingAttributes = (tracking: StoryCardTracking) =>
  tracking === 'ignore'
    ? { 'data-tracking': 'ignore' as const }
    : {
        'data-track': true,
        'data-event-name': tracking.eventName,
        'data-event-position': tracking.position,
        'data-event-origin': tracking.origin,
      }
